"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconMinimize = function IconMinimize(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconMinimize', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    id: "a",
    d: "M4 .8v2.4a.8.8 0 0 1-.8.8H.8a.8.8 0 1 0 0 1.6h2.4a2.4 2.4 0 0 0 2.4-2.4V.8A.8.8 0 1 0 4 .8zM15.2 4h-2.4a.8.8 0 0 1-.8-.8V.8a.8.8 0 1 0-1.6 0v2.4a2.4 2.4 0 0 0 2.4 2.4h2.4a.8.8 0 1 0 0-1.6zM12 15.2v-2.4a.8.8 0 0 1 .8-.8h2.4a.8.8 0 1 0 0-1.6h-2.4a2.4 2.4 0 0 0-2.4 2.4v2.4a.8.8 0 1 0 1.6 0zM.8 12h2.4a.8.8 0 0 1 .8.8v2.4a.8.8 0 1 0 1.6 0v-2.4a2.4 2.4 0 0 0-2.4-2.4H.8a.8.8 0 1 0 0 1.6z"
  }));
};

var _default = IconMinimize;
exports.default = _default;